const contentClass = "collapsible-content";
const headerClass = "collapsible-header";
const hideClass = "hide";
const iconClassExpanded = "fa-caret-down";
const iconClassCollapsed = "fa-caret-right";
const labelClass = "collapsible-label";

export {
  contentClass,
  hideClass,
  headerClass,
  iconClassCollapsed,
  iconClassExpanded,
  labelClass,
};
